import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [
    'providerSettingsFieldset',
    'leftoverProvidersSection',
    'providerCheckbox',
  ];

  connect() {
    // Initialize visibility on connect
    this.updateDeviceFieldsets();
    this.updateLeftoverProvidersVisibility();
  }

  toggleDeviceOptions(event) {
    const radio = event.target;
    const provider = radio.dataset.provider;
    const selectedValue = radio.value;

    // Find all fieldsets for this provider and update their visibility
    this.providerSettingsFieldsetTargets.forEach((fieldset) => {
      const fieldsetProvider = fieldset.dataset.provider;
      const radioButtonsValue = fieldset.dataset.radioButtonsValue;

      if (fieldsetProvider === provider) {
        // Split radioButtonsValue by semicolon to support multiple values
        const allowedValues = radioButtonsValue.split(';').map((v) => v.trim());

        if (allowedValues.includes(selectedValue)) {
          fieldset.classList.remove('d-none');
          fieldset.disabled = false;
        } else {
          fieldset.classList.add('d-none');
          fieldset.disabled = true;
        }
      }
    });
  }

  updateDeviceFieldsets() {
    // Update all fieldsets based on current radio button states
    this.providerSettingsFieldsetTargets.forEach((fieldset) => {
      const provider = fieldset.dataset.provider;
      const radioButtonsValue = fieldset.dataset.radioButtonsValue;

      const radios = this.element.querySelectorAll(
        `input[type="radio"][data-provider="${provider}"]`
      );

      const checkedRadio = Array.from(radios).find((radio) => radio.checked);

      if (checkedRadio) {
        // Split radioButtonsValue by semicolon to support multiple values
        const allowedValues = radioButtonsValue.split(';').map((v) => v.trim());

        if (allowedValues.includes(checkedRadio.value)) {
          fieldset.classList.remove('d-none');
          fieldset.disabled = false;
        } else {
          fieldset.classList.add('d-none');
          fieldset.disabled = true;
        }
      } else {
        fieldset.classList.add('d-none');
        fieldset.disabled = true;
      }
    });
  }

  toggleProviderEnabled() {
    this.updateLeftoverProvidersVisibility();
  }

  updateLeftoverProvidersVisibility() {
    if (!this.hasLeftoverProvidersSectionTarget) return;

    // Check if there are any unchecked provider checkboxes
    const hasUncheckedProviders = this.providerCheckboxTargets.some(
      (checkbox) => !checkbox.checked
    );

    // Show section if there are unchecked providers, hide if all are checked
    if (hasUncheckedProviders) {
      this.leftoverProvidersSectionTarget.classList.remove('d-none');
    } else {
      this.leftoverProvidersSectionTarget.classList.add('d-none');
    }
  }
}
